import React, { useContext } from 'react';
import { Appbar, Card, IconButton, Text } from 'react-native-paper';
import { ScrollView } from 'react-native';
import { useMutation, useQuery } from '@apollo/client';
import { useToast } from 'react-native-toast-notifications';
import { ModalContext } from '../../context/ModalContext';
import ManageDriverGroupModal from '../../modals/ManageDriverGroup/ManageDriverGroupModal';
import RefreshableScreen from '../Refreshable/RefreshableScreen';
import LoadingIndicator from '../../components/commons/LoadingIndicator';
import { GET_DRIVER_GROUPS } from '../../gql/driver-group/query';
import { DELETE_DRIVER_GROUP } from '../../gql/driver-group/mutation';

function ManageDriverGroupsScreen() {
  const toast = useToast();
  const {
    displayManageDriverGroupModal,
    toggleManageDriverGroupModal,
    toggleConfirmationModal,
  } = useContext(ModalContext);

  const { data, loading, refetch } = useQuery(GET_DRIVER_GROUPS);

  const [deleteDriverGroup] = useMutation(DELETE_DRIVER_GROUP, {
    onCompleted: () => {
      toast.show('Groupe supprimé.');
      refetch();
    },
    onError: (err) => toast.show(err.message),
    refetchQueries: [{ query: GET_DRIVER_GROUPS }],
  });

  const handleCreate = () => {
    toggleManageDriverGroupModal({
      title: 'Créer un groupe de conducteurs',
      onSave: refetch,
    });
  };

  const handleEdit = (group) => {
    toggleManageDriverGroupModal({
      title: 'Modifier le groupe',
      driverGroup: group,
      onSave: refetch,
    });
  };

  const handleDelete = (group) => {
    toggleConfirmationModal({
      title: 'Confirmation',
      message: `Voulez-vous vraiment supprimer le groupe "${group.name}" ?`,
      handleSubmit: async () => {
        await deleteDriverGroup({ variables: { id: group.id } });
      },
    });
  };

  return (
    <>
      <Appbar.Header statusBarHeight={0}>
        <Appbar.Content title="Groupes de conducteurs" />
        <Appbar.Action icon="plus" onPress={handleCreate} />
      </Appbar.Header>
      <RefreshableScreen onRefresh={async () => { await refetch(); }}>
        {loading && <LoadingIndicator text="Chargement des groupes..." />}
        {displayManageDriverGroupModal.display && <ManageDriverGroupModal />}
        <ScrollView>
          {(data?.driverGroups ?? []).map((group) => (
            <Card key={group.id} style={{ margin: 8 }}>
              <Card.Title
                title={group.name}
                subtitle={group.description || `${group.members.length} conducteur(s)`}
              />
              {!group.description && null}
              {group.description ? (
                <Card.Content>
                  <Text variant="bodySmall" style={{ color: '#666' }}>
                    {group.members.length} conducteur(s)
                  </Text>
                </Card.Content>
              ) : null}
              <Card.Actions>
                <IconButton icon="application-edit" onPress={() => handleEdit(group)} />
                <IconButton icon="delete" onPress={() => handleDelete(group)} />
              </Card.Actions>
            </Card>
          ))}
        </ScrollView>
      </RefreshableScreen>
    </>
  );
}

export default ManageDriverGroupsScreen;
